$settings-links-active-color:'#B7CFE2' !default;
$settings-links-active-border-color:'#596E7E' !default;
$settings-links-color:'#a7b1c2' !default;
$settings-links-active-background1:'#182C39' !default;
$settings-links-active-background2:'#2A475A' !default;
$settings-links-active-box-shadow:'black' !default;

.nav-header {
  ul {
    li {
      border-bottom: 1px dashed #{$settings-links-active-color};
      a {
        color: #{$settings-links-color};
      }
    }
  }

  .activeLink {
    background: linear-gradient( 0deg,#{$settings-links-active-background1}, #{$settings-links-active-background2});
    border:2px solid #{$settings-links-active-border-color};
    -webkit-box-shadow: 0 6px 2px -2px  #{$settings-links-active-box-shadow};
    -moz-box-shadow: 0 6px 2px -2px  #{$settings-links-active-box-shadow};
    box-shadow: 0 6px 2px -2px #{$settings-links-active-box-shadow};
    a{
      color: #{$settings-links-active-color} !important;
    }
  }
}






// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/settings/settings-links/settings-links-theme.scss